export default __webpack_public_path__ + "static/kiory-d83e7e7fb8f89083737736a2e9a17a21.png";